import { createStitches } from '@stitches/react';

export const { getCssText, styled, css, globalCss } = createStitches();
